const familyDiseases = [
    "Diabetes",
    "Hipertensión arterial",
    "Dislipidemias (colesterol o triglicéridos altos)",
    "Insuficiencia renal",
    "Infartos cardiacos o cerebrales",
    "Ansiedad",
    "Depresión",
    "Cáncer",
  ];
  
  export default familyDiseases;
  